import { ArticleType } from '@stadionhq-v3/base-ui';
import { Article, Gallery, Play } from '@components/icons';

const generateCardIcon = (articleType: ArticleType) => {
  switch (articleType) {
    case 'News':
      return { icon: <Article /> };
    case 'Gallery':
      return { icon: <Gallery /> };
    case 'Video':
      return { icon: <Play /> };
    default:
      return { icon: <Article /> };
  }
};

export default generateCardIcon;
